import { createFileRoute, Outlet } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';
import { ProjectSocAutomationProvider } from '@views/SocAutomation/context/ProjectSocAutomationProvider';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/threats/soc-automations')({
  beforeLoad: () => getTitleContextSlice('Automations'),
  staticData: {
    owner: CodeOwner.SWB,
  },
  component: () => (
    <ProjectSocAutomationProvider>
      <Outlet />
    </ProjectSocAutomationProvider>
  ),
});
